import { guidebookSteps } from 'components/content/guidebook/content'
import { GuidebookHero } from 'components/content/guidebook/guidebookHero/GuidebookHero'
import { PrimaryLink } from 'components/Link'
import { Stack } from 'components/Stack'
import { useTranslation } from 'next-i18next'
import { scrollToRect } from 'utils/general'

export type GuidebookIntroProps = {
  noFullPageScroll?: boolean
}

export function GuidebookIntro(props: GuidebookIntroProps) {
  const { t } = useTranslation('eol_guide')

  return (
    <GuidebookHero
      title={t('eol_guide.hero.title')}
      titleAs="h1"
      description={t('eol_guide.hero.description')}
      action={
        <Stack space={0.2}>
          {guidebookSteps.map((step) => (
            <PrimaryLink
              key={step.id}
              href={`#${step.id}`}
              onClick={(ev) => {
                if (props.noFullPageScroll) {
                  return
                }
                ev.preventDefault()
                // the section hash will get automatically updated by useSectionsInHash, just by scrolling there
                // so we prevent the default behaviour and thanks to that, we can get a smooth scroll experience
                const section = document.getElementById(step.id)
                if (section) {
                  scrollToRect(section.getBoundingClientRect())
                }
              }}
            >
              {t('eol_guide.step_x', { step: step.no })} - {t(`eol_guide.step_names.${step.no}`)}
            </PrimaryLink>
          ))}
        </Stack>
      }
      image={<img src={`/images/guidebook/hero-image1@2x.jpg`} />}
    />
  )
}
